var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.01333H27C27.0495 1.01333 27.0982 1.01698 27.1458 1.02402L14.7976 10.2927C14.6208 10.4255 14.3792 10.4255 14.2024 10.2927L1.85425 1.02402C1.90183 1.01698 1.95049 1.01333 2 1.01333ZM1.05754 1.68706C1.02028 1.79322 1 1.90754 1 2.02667V16.9733C1 17.533 1.44772 17.9867 2 17.9867H5.17857H11.3929H27C27.5523 17.9867 28 17.533 28 16.9733V2.02667C28 1.90754 27.9797 1.79322 27.9425 1.68706L15.3928 11.107C14.8624 11.5051 14.1376 11.5051 13.6072 11.107L1.05754 1.68706ZM27 0H2C0.895431 0 0 0.90737 0 2.02667V16.9733C0 18.0926 0.89543 19 2 19H5.17857H11.3929H27C28.1046 19 29 18.0926 29 16.9733V2.02667C29 0.90737 28.1046 0 27 0Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.29747116.svg";
export { ForwardRef as ReactComponent };